import api from "./api";
import { notify } from "./toast";
import { money } from "./format";

/**
 * Called after a transaction is created. Fetches current-month budget status
 * and fires a toast if any budget for the same category is over or near limit.
 */
export async function checkBudgetAfterTx(tx) {
  if (!tx || tx.type !== "expense") return;
  try {
    const r = await api.get("/budgets/status");
    const hit = r.data.find((b) => b.category === tx.category);
    if (!hit) return;
    if (hit.over) {
      notify.error(
        `${hit.category} bütçesi aşıldı — ${money(hit.spent)} / ${money(hit.monthly_limit)}`,
      );
    } else if (hit.percent >= 80) {
      notify.info(
        `${hit.category} bütçesinin %${hit.percent.toFixed(0)}'i kullanıldı`,
      );
    }
  } catch {
    // silent
  }
}
